"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LensFieldDetailsDialog = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var Localize_1 = require("../../../gen-src/Localize");
var LensFieldDetailsQueryGql_1 = require("../../queries/LensFieldDetailsQueryGql");
var FieldDetailsDialog_1 = require("../FieldDetails/FieldDetailsDialog");
var FieldPropertyComponents_1 = require("../FieldDetails/FieldPropertyComponents");
var SvgFieldIcon_1 = require("../field/components/SvgFieldIcon");
var FieldFunctions_1 = require("../field/functions/FieldFunctions");
var FieldNameMapping_1 = require("../field/functions/FieldNameMapping");
var renderQueryResult_1 = require("../renderQueryResult");
var dialogWidth = 500;
var LensFieldDetailsDialog = /** @class */ (function (_super) {
    __extends(LensFieldDetailsDialog, _super);
    function LensFieldDetailsDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderLensFieldDetails = function (data) {
            var _a, _b;
            var field = data.lensFields && data.lensFields[0];
            if (!field) {
                return null;
            }
            var fieldIcon = FieldFunctions_1.iconForField(field.datasourceField);
            var datasource = (_a = field === null || field === void 0 ? void 0 : field.datasourceField) === null || _a === void 0 ? void 0 : _a.datasource;
            var datasourceVizPortalUrlId = (datasource === null || datasource === void 0 ? void 0 : datasource.__typename) === 'PublishedDatasource' ? datasource === null || datasource === void 0 ? void 0 : datasource.vizportalUrlId : null;
            return (React.createElement(widgets_1.DialogWidget, { testId: 'field-details', title: Localize_1.Messages.FieldDetails(), type: widgets_1.DialogType.NormalWithTitleBar, positioningBehavior: widgets_1.DialogPositioningBehavior.Centered, dialogWidth: dialogWidth, showCloseButton: true, showFooter: false, isModal: true, onCloseRequest: _this.props.onClose, handleGlassClick: _this.props.onClose },
                React.createElement(FieldDetailsDialog_1.FieldDetailsPane, null,
                    React.createElement(FieldDetailsDialog_1.FieldDetailsFieldName, null, field.name || field.datasourceField.name),
                    React.createElement(FieldDetailsDialog_1.FieldDetailsTypeRow, null,
                        React.createElement(SvgFieldIcon_1.SvgFieldIcon, { fieldIcon: fieldIcon }),
                        fieldIcon ? FieldNameMapping_1.FieldNameMappings[fieldIcon]() : null),
                    React.createElement(FieldDetailsDialog_1.FieldDetailsProperties, null,
                        React.createElement(FieldPropertyComponents_1.FieldPropertyDescription, { labelFunc: Localize_1.Messages.Description, description: field.description || field.datasourceField.description }),
                        _this.renderTypeSpecificFieldDetails(field.datasourceField),
                        React.createElement(FieldPropertyComponents_1.ConnectedDatasourceField, { datasourceVizPortalUrlId: datasourceVizPortalUrlId, fieldId: field === null || field === void 0 ? void 0 : field.datasourceField.id, fieldName: (_b = field === null || field === void 0 ? void 0 : field.datasourceField) === null || _b === void 0 ? void 0 : _b.name })))));
        };
        return _this;
    }
    LensFieldDetailsDialog.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_apollo_1.Query, { query: LensFieldDetailsQueryGql_1.LensFieldDetailsQueryGql, variables: { lensFieldId: this.props.fieldId } }, function (result) { return renderQueryResult_1.renderQueryResult(result, { renderData: _this.renderLensFieldDetails }); }));
    };
    LensFieldDetailsDialog.prototype.renderTypeSpecificFieldDetails = function (field) {
        if (field.__typename !== 'DatasourceField') {
            return FieldDetailsDialog_1.renderTypeSpecificNonDatasourceFieldDetails(field, this.props.makeFieldUrl);
        }
        else if (field.remoteField) {
            return FieldDetailsDialog_1.renderTypeSpecificNonDatasourceFieldDetails(field.remoteField, this.props.makeFieldUrl);
        }
        else {
            return null;
        }
    };
    return LensFieldDetailsDialog;
}(React.Component));
exports.LensFieldDetailsDialog = LensFieldDetailsDialog;
//# sourceMappingURL=LensFieldDetailsDialog.js.map